import { forwardRef, type ClipboardEvent, type InputHTMLAttributes } from 'react';
import { formatPhoneInputRu } from '../widget-lib/phone';

export type EmbedPhoneInputProps = Omit<InputHTMLAttributes<HTMLInputElement>, 'value' | 'onChange' | 'type'> & {
  value: string;
  onChange: (next: string) => void;
};

/**
 * Ввод телефона РФ для embed: отображение через {@link formatPhoneInputRu} (как в виджете),
 * чтобы в поле не оставались «голые» цифры без маски.
 */
export const EmbedPhoneInput = forwardRef<HTMLInputElement, EmbedPhoneInputProps>(function EmbedPhoneInput(
  { value, onChange, className, placeholder, ...rest },
  ref
) {
  const handlePaste = (e: ClipboardEvent<HTMLInputElement>) => {
    const pasted = e.clipboardData.getData('text').replace(/[^\d]/g, '');
    if (!pasted) return;
    e.preventDefault();
    const hasPlus = value.trim().startsWith('+7');
    const cleaned = hasPlus ? pasted.replace(/^7/, '') : pasted;
    const raw = (hasPlus ? '+7 ' : '') + cleaned;
    onChange(formatPhoneInputRu(raw));
  };

  return (
    <input
      ref={ref}
      type="tel"
      inputMode="tel"
      autoComplete="tel"
      placeholder={placeholder ?? '+7 999 123-45-67'}
      className={className}
      value={formatPhoneInputRu(value)}
      onChange={(e) => onChange(formatPhoneInputRu(e.target.value))}
      onPaste={handlePaste}
      {...rest}
    />
  );
});
